import { Paper, Typography } from '@material-ui/core';
import styled from 'styled-components';

export interface PaddedPaperProps {
  x?: string | number;
  y?: string | number;
  noMargin?: boolean;
}

export const PaddedPaper = styled(Paper).attrs({
  elevation: 0,
})<PaddedPaperProps>`
  &&& {
    margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '80px')};
    padding: ${({ x, y }) => {
      let xStr = '50px';
      let yStr = '35px';

      if (x) {
        if (typeof x === 'number') {
          xStr = `${x}px`;
        } else {
          xStr = x;
        }
      }

      if (y) {
        if (typeof y === 'number') {
          yStr = `${y}px`;
        } else {
          yStr = y;
        }
      }

      return `${yStr} ${xStr}`;
    }};
  }
`;

export const StickyPaddedPaper = styled(PaddedPaper)`
  &&& {
    position: sticky;
    top: 0;
  }
`;

export const PaddedPaperTitle = styled(Typography).attrs({
  variant: 'h6',
  component: 'h2',
})`
  &&& {
    font-family: 'Lato', sans-serif;
    font-weight: 600;
    margin-bottom: 40px;
  }
`;

export default PaddedPaper;
